import { TOKEN_KEY } from '../constants/auth'

export const getItemFromSessionStorage = (key) => {
  try {
    const fromSession = sessionStorage.getItem(key)

    return fromSession ? JSON.parse(fromSession) : null
  } catch (e) {
    throw new Error('There was an error getting from the sessionStorage')
  }
}

export const setItemInSessionStorage = (key, value) => {
  try {
    const toSession = JSON.stringify(value)
    sessionStorage.setItem(key, toSession)
  } catch (e) {
    throw new Error('There was an error writing to the sessionStorage')
  }
}

export const removeItemFromSessionStorage = (key) => {
  try {
    sessionStorage.removeItem(key)
  } catch (e) {
    throw new Error('There was an error deleting from the sessionStorage')
  }
}

export const removeToken = () => {
  removeItemFromSessionStorage(TOKEN_KEY)
}

export const getToken = () => getItemFromSessionStorage(TOKEN_KEY)

export const setToken = (token) => {
  setItemInSessionStorage(TOKEN_KEY, token)
}
